export function generateImageLink(playbackId: string, time = 0): string {
	return `https://image.mux.com/${playbackId}/thumbnail.jpg?width=800&time=${time}`
}

export function generateAnimatedImageLink(
	playbackId: string,
	time = 0,
): string {
	return `https://image.mux.com/${playbackId}/animated.gif?width=500&time=${time}&fps=24`
}
